import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { MeetingRoom } from '@mui/icons-material';
import { Unit } from '../../Types/UnitFeatureTypes';
import { useNavigate } from 'react-router-dom';

// Define types for the user card props
interface UnitCardProps {
  unit?: Unit;
}

const UnitCard: React.FC<UnitCardProps> = ({ unit }) => {

  const navigate = useNavigate();
  if (!unit) {
    return null;
  }

  const handleOnClick = () => {
    navigate(`/unitFile`, { state: {unit_id: unit.id} });
  };

  return (
    <Card 
    onClick={handleOnClick}
      sx={{
        display: 'flex',
        padding: 2,
        borderRadius: 3,
        width: 300,
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        alignItems: 'center',
        justifyContent: 'space-between',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: '#f9f9f8',
          transform: 'scale(1.01)',
          transition: 'transform 1s',
        },
      }}>
      <MeetingRoom sx={{width: 120, height: 120}} />

      <CardContent sx={{height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
        <Typography color={'secondary.main'} variant="h6" sx={{ fontWeight: 'bold' }}>Unit: {unit.unit_number}</Typography>
        <Typography variant="subtitle1">Unit Type: {unit.unit_type}</Typography>
        {unit.locker_number && <Typography variant="subtitle1">Locker: {unit.locker_number}</Typography>}
        {unit.parking_slot && <Typography variant="subtitle1">Parking: {unit.parking_slot}</Typography>}
{/*         
        <Typography variant="subtitle1">Unit Type: {bookingUnit.floor_number}</Typography>
        <Typography variant="subtitle1">Floor: {bookingUnit.floor_number}</Typography> */}

      </CardContent>
    </Card>
  );
};

export default UnitCard;
